import BaseModel from '../base';
import CertificateProfile from '../certificate-profile';

export default class GiftedChild extends BaseModel {
  constructor(child = {}, url = '') {
    super(child, url);

    this.user_id = child.user_id;
    this.event_rating_id = child.event_rating_id || null;
    this.event_rating_name = child.event_rating_name || null;
    this.rating = Number(child.rating) ?? 0;
    this.filters = child.filters || [];
    this.profile = new CertificateProfile(child.profile || {});
  }
}
